
import { useState } from 'react';
import './OutrasOpcoes.css';

function OutrasOpcoes({propostas}) {
    console.log(propostas.valorTotalProposta)

    function fnOutrasOpcoes(id, valor, prazo) {
        var elems = document.querySelectorAll(".creditoAprovado2");
        [].forEach.call(elems, function(el) {
            el.classList.remove("bc-azul");
        });

        var elems2 = document.querySelectorAll(".bulletSel");
        [].forEach.call(elems2, function(el) {
            el.classList.remove("bc-azul");
        });

        var element = document.getElementById(`bl-${id}`)
        element.classList.add("bc-azul")

        var elementBullet = document.getElementById(`blt-${id}`)
        elementBullet.classList.add("bc-azul")

        var elValor = document.getElementById("valorSimulacao")
        elValor.value = valor;

        var elParcela = document.getElementById("parcelaSimulacao")
        elParcela.value = prazo;
    }

    const results = [];

    results.push(
        <div className='melhorOpcao2'>Selecione o valor desejado</div>
    )
    
    propostas.outrasPropostas.forEach((employee, index) => {
        if(index >0 ){
            results.push(
                <div id={"bl-"+ (index)} key={index} className="creditoAprovado2" onClick={() => fnOutrasOpcoes(index, employee.valor, employee.prazo)}>
                    <div id={"blt-"+ (index)}  className='bulletSel'></div>
                    <div className='tit'>{propostas.valorTotalProposta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</div>
                    <div className='desc'>{employee.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} em {employee.prazo} vezes</div>
                </div>
            )
        }
    })

    return (
      results 
    )

}

export default OutrasOpcoes;